///////This is just an abbreviated checkout page that allows clients to pay deposits on their own

import React from "react";
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import "./checkout.css";
import { Blocks } from "react-loader-spinner";
import lawService from "./customAjax";

function DepositByClient() {
  const [paidLoading, setPaidLoading] = useState({
    payment: true,
    goodToClose: false,
    isError: false,
    matterId: 0,
    matterFirstName: "",
    matterLastName: "",
    matterEmail:"",
    showError:false,
    depositBalance:0,
    case_blurb:""
  });


  const [searchParams, setSearchParams] = useSearchParams();
  const handleMessage = async (m) => {
    if (m.data.type === "pd:page_success") {
      successHandler();
    }
  };
  window.addEventListener("popstate", (event) => {
    window.removeEventListener("message", handleMessage);
  });

  ////we send client an email with a link to this page with their matter ID in the search params
  ////These params make sure this link links to the proper matter and can mark that they made the deposit
  ////other than this, this is very very similar to the checkout page
  const successHandler = async () => {
    const matterId = searchParams.get("matter");
    const matterResponse = await lawService.getMatterById(matterId)
    const matterEmail = matterResponse.data.data.attributes.email;
    const matterFirstName = matterResponse.data.data.attributes.first_name;
    console.log(matterEmail,matterFirstName)
   lawService.submitDepositForm(matterEmail,matterFirstName,  "Custom", true);
   setPaidLoading((ps) => {
    let pd = { ...ps };
    pd.payment = false;
    return pd;
  });
  };
  const onGetMatterSuccess = async (r) => {
    const matterEmail = r.data.data.attributes.email;
    const matterFirstName = r.data.data.attributes.first_name;
    const matterFullName = r.data.data.attributes.name;
    const custom_fields = r.data.data.attributes.custom_fields;
    const matterLastName= matterFullName.split(" ")[1];
    let depositAmount=0
    let case_blurb
    let case_title
    let spouseName=0
    for (let i = 0; i < custom_fields.length; i++) {
      const element = custom_fields[i];
      if (element.id === "421736") {
        spouseName = element.value;
      }
      if (element.id === "563798") {
        depositAmount = element.value;
      }
      
    }
        if (spouseName != 0) {
          try {
            let spouseResponse = await lawService.getContactById(
              spouseName
            );
            let spouseFirstname = spouseResponse.data.data.attributes.first_name;
            let spouseLastname = spouseResponse.data.data.attributes.last_name;
            if (spouseLastname == matterLastName) {
              case_blurb = `${matterFirstName} and ${spouseFirstname} ${matterLastName}`;
              case_title = `${matterLastName}, ${matterFirstName} and ${spouseFirstname}`;
            }
            if (spouseLastname != matterLastName) {
              case_blurb = `${matterFirstName} ${matterLastName} and ${spouseFirstname} ${spouseLastname}`;
              case_title = `${matterLastName}, ${matterFirstName} and ${spouseFirstname} ${spouseLastname}`;
            }
          } catch {
            case_blurb = `${matterFirstName} ${matterLastName}`;
            case_title = `${matterLastName}, ${matterFirstName}`;
          }
        }
        if (spouseName === 0) {
          case_blurb = `${matterFirstName} ${matterLastName}`;
          case_title = `${matterLastName}, ${matterFirstName}`;
        }
    console.log(case_blurb,case_title)
    setPaidLoading((prevState) => {
      const pd = {
        ...prevState,
      };
      pd.matterFirstName = matterFirstName;
      pd.matterFullName = matterFullName;
      pd.matterEmail=matterEmail
      pd.showError=false
      pd.case_blurb=case_blurb
      pd.depositBalance=depositAmount
      return pd;
    });
   
  };
  const onGetMatterFail = (e) => {
    setPaidLoading((prevState) => {
      const pd = {
        ...prevState,
      };
      pd.matterFirstName = 0;
      pd.matterFullName = 0;
      pd.matterEmail=0
      pd.matterId=0
      pd.showError=true
      return pd;
    });
  };
  useEffect(() => {
    window.addEventListener("message", handleMessage);
    const matterId = searchParams.get("matter");
    setPaidLoading((prevState) => {
      const pd = {
        ...prevState,
      };
      pd.matterId = searchParams;
      return pd;
    });
    lawService
      .getMatterById(matterId)
      .then((r) => {
        console.log(r)
        onGetMatterSuccess(r);
      })
      .catch((e) => onGetMatterFail(e));
  }, []);
  return (
    <>
    {paidLoading.depositBalance ===0 && <div>
      {!paidLoading.showError && (
        <div>
          {paidLoading.payment && (
            <div >
              <iframe
                style={{ width: "1000px", height: "1000px" }} //neil changed below one may 20
                src={`https://pay.confidolegal.com/standing-link/5e6c3a6d-e79d-49dc-935c-21de9740d111?amount=25000&clientNotes=Design Meeting Deposit for ${paidLoading.case_blurb }`}
                //src={`https://pay.sandbox.gravity-legal.com/standing-link/a4f08084-6dc5-449d-9e6b-98ff426057d5?amount=25000&clientNotes=Design Meeting Deposit for ${paidLoading.case_blurb}`}
              ></iframe>
            </div>
          )}
          {!paidLoading.payment && (
            <div>
            <h3 >
              Payment Received and Processed.<br></br>You will receive and email to schedule your design
              consultation shortly!
            </h3>
            </div>
          )}
        </div>
      )}
      {paidLoading.showError && (
        <div>
          <h3 >
            We couldn't seem to pull up your record in our system. <br></br>It's possible you may be in the wrong place. Please click <a href="https://inheritguard.com/contact">here</a> to get in contact with our support team.
          </h3>
        </div>
      )}
      </div>}
      {paidLoading.depositBalance>0 && <div>
          <h3 >
            You seem to have already made your design meeting deposit.<br></br>If you believe this is a mistake, please click <a href="https://inheritguard.com/contact">here</a> to get in contact with our support team.
          </h3>
        </div>}
    </>
  );
}
export default DepositByClient;
